import { render, staticRenderFns } from "./HostsTable.vue?vue&type=template&id=447d337b&scoped=true"
import script from "./HostsTable.vue?vue&type=script&lang=js"
export * from "./HostsTable.vue?vue&type=script&lang=js"
import style0 from "./HostsTable.vue?vue&type=style&index=0&id=447d337b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447d337b",
  null
  
)

export default component.exports